import React, { useMemo, useState } from 'react';
import { Camera, CameraOff, X } from 'lucide-react';
import { useZxing } from 'react-zxing';
import './MemberPassScannerModal.css';

const ignoredDecodeErrors = new Set(['NotFoundException', 'ChecksumException', 'FormatException']);

const MemberPassScannerModal = ({
    isOpen,
    onClose,
    onDetected,
    title = 'Scan Member Pass QR',
    description = 'Point your camera at the member pass QR code.'
}) => {
    const [scannerError, setScannerError] = useState('');

    const constraints = useMemo(
        () => ({
            video: {
                facingMode: { ideal: 'environment' }
            },
            audio: false
        }),
        []
    );

    const { ref } = useZxing({
        paused: !isOpen,
        constraints,
        timeBetweenDecodingAttempts: 200,
        onDecodeResult(result) {
            const value = result?.getText?.()?.trim();
            if (value) {
                onDetected(value);
            }
        },
        onDecodeError(error) {
            if (!ignoredDecodeErrors.has(error?.name)) {
                setScannerError('Unable to decode QR yet. Try improving lighting or distance.');
            }
        },
        onError() {
            setScannerError('Camera access is unavailable on this device/browser.');
        }
    });

    if (!isOpen) {
        return null;
    }

    return (
        <div className="member-pass-scanner-overlay" onClick={onClose}>
            <div className="member-pass-scanner-modal" onClick={(event) => event.stopPropagation()}>
                <div className="member-pass-scanner-header">
                    <div>
                        <h3>{title}</h3>
                        <p>{description}</p>
                    </div>
                    <button type="button" className="member-pass-scanner-close" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>
                <div className="member-pass-scanner-video-wrap">
                    <video ref={ref} className="member-pass-scanner-video" />
                </div>
                {scannerError ? (
                    <p className="member-pass-scanner-error">
                        <CameraOff size={14} />
                        {scannerError}
                    </p>
                ) : (
                    <p className="member-pass-scanner-hint">
                        <Camera size={14} />
                        Hold steady for auto-detection.
                    </p>
                )}
            </div>
        </div>
    );
};

export default MemberPassScannerModal;
